export const TagItem = ({ nomeTag, cor }) => {
    return (
        
        <div className={"rounded-sm border-violet-300 border text-xs text-[9px] flex flex-row h-6 bg-slate-200"} variant={"outline"}>
            <div className='px-1 py-0.5 text-[10px]'>
            {nomeTag.substr(0, 20)}{nomeTag.length > 20 && '..'}
            </div>
        </div>
    );
  }